import lang from "element-ui/lib/locale/lang/en"
import locale from "element-ui/lib/locale"

// 设置 Element UI 的国际化
locale.use(lang)
